


































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { http } from "@/shared/https";
import AuthService from "@/services/auth.service";

const auth = new AuthService();

@Component({
  components: {},
})
export default class UserProfileComponent extends Vue {
  public oldPassword: string;
  public newPassword: string;
  public confirmPassword: string;
  public showPasswordOld: boolean = false;
  public showPasswordNew: boolean = false;
  public showPasswordConfirm: boolean = false;  
  private Status: string = "";
  private snackColor: string = "";
  private snackBar: boolean = false;
  private selectedFile: any;
  private fileName: string = "";
  private Imageurl: any = "";
  private Acronym: string = "";
  passwordIconOff:string="mdi-eye-off";
  passwordIconOn:string="mdi-eye";
      
  //Submits the change password form after validation
  Submit(): any {
    if ((this.$refs.form1 as Vue & { validate: () => boolean }).validate()) {
      auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          auth.getUser().then((user) => {
            var data = {
              Id: user.profile.sub,
              OldPassword: this.oldPassword,
              newPassword: this.newPassword,
              confirmPassword: this.confirmPassword              
            };

            http.put("/api/Profile/ChangePassword/", data).then((resp: any) => {
              this.snackBar = true;

              if (resp.status >= 200 && resp.status < 300) {
                //@ts-ignore
                this.$refs.form1.reset();
                var result = resp.data.Value;

                if (result.Result === "OK") {
                  this.Status = result.Message;
                  this.snackColor = "green";
                  sessionStorage.removeItem("passwordNotify");                  
                } else {
                  this.Status = result.Message;
                  this.snackColor = "red";
                }
              } else {
                this.Status = "Change password operation failed.";
                this.snackColor = "red darken-2";
              }
            });
          });
        }
      });
    }
  }

  //Function to check  if old password and new password are same . Validation fails if they are same

  MacthingCheck(): boolean {
    if (this.oldPassword == this.newPassword) {
      return true;
    } else {
      return false;
    }
  }

  //Function to check  if new password and confirm password are same . Validation fails if they are not same

  MacthingCheck2(): boolean {
    if (this.newPassword == this.confirmPassword) {
      return true;
    } else {
      return false;
    }
  } 
  
}
